import axios from 'axios'
import global from '@/global'

const api = axios.create({
    baseURL:'/api/v1/',
    //headers:{
    //        authorization: "Bearer " + global.authenticated.value.token,
    //}
})

api.interceptors.request.use((config) => {
    const token = global.authenticated.value?.token;
    if (token) {
      config.headers.authorization = `Bearer ${token}`;
    }
    return config;
});

// Add retry logic for failed requests (especially uploads).
// Intentional cancellations (AbortController) and explicit noRetry: true bypass retries.
api.interceptors.response.use(
    response => response,
    async error => {
        const { config } = error;
        if (!config) return Promise.reject(error);

        // The access token ran out (a laptop asleep past its refresh): renew it once and retry the request.
        if (error.response?.data?.flag === 'token_expired' && !config._renewed) {
            config._renewed = true;
            const result = await global.refreshNow();
            if (result === 'renewed') { return api(config); }
            if (result === 'refused') { global.logout({ serverEnded: true }); }
            return Promise.reject(error);
        }

        // The server signed this user out (password reset, admin lock): every tab goes to sign in.
        if (error.response?.data?.flag === 'signed_out') {
            global.logout({ serverEnded: true });
            return Promise.reject(error);
        }

        // Never retry intentional cancellations — we aborted the request on purpose.
        if (error.code === 'ERR_CANCELED' || error.name === 'CanceledError') {
            return Promise.reject(error);
        }

        // Initialize the retry counter ONCE on the first failure for this config.
        // Use `=== undefined` so a counter that has decremented to 0 doesn't reset back to 3
        // (the previous `!config.retry` check did that and produced an infinite retry loop).
        if (config.retry === undefined) {
            config.retry = 3;
        }

        const msg = error.message || '';
        // Only retry on network errors or timeouts (opt out with noRetry: true for non-idempotent requests).
        if (config.retry > 0 && !config.noRetry && (
            error.code === 'ECONNABORTED' ||
            msg.includes('Network Error') ||
            msg.includes('timeout') ||
            !error.response // No response means network issue
        )) {
            config.retry -= 1;
            console.log(`Retrying request... (${3 - config.retry}/3)`);
            await new Promise(resolve => setTimeout(resolve, 1000));
            return api(config);
        }

        return Promise.reject(error);
    }
);

export default api